import qs from 'qs';
import { network } from 'services/network';

export const getComponentColumns = ({ componentId }) => {
    const querystring = qs.stringify({ componentId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/getComponentColumns${querystring}`;

    return network.post(url).then((response) => (response.data.columns ? JSON.parse(response.data.columns) : null));
};
